/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {UgcItemInterface} from '@/store/modules/ugc-item/types';

/**
 * UGC build item interface.
 *
 * Represents a UGC build item document object.
 */
export interface UgcRevisionInterface {
    id?: string;
    userId?: number;
    itemId?: string;
    artifact?: string;
    revisionNotes?: string;
    status: string;
    item: any;
    originalItem?: UgcBuildInterface;
    createdAt: number;
    updatedAt: number;
}

/**
 * UGC build item interface.
 *
 * Represents a UGC build item document object.
 */
export interface UgcBuildInterface {
    id?: string;
    userId?: number;
    itemId?: string;
    revisionNotes: string;
    status: string;
    name: string;
    description: string;
    price: number|null;
    runningCost: number|null;
    placementSound: number;
    placementSoundSize: number;
    category: string;
    flexicolorOne: string;
    flexicolorTwo: string;
    flexicolorThree: string;
    flexicolorFour: string;
    theme: string;
    sceneryType: string;
    imgUuid: string;
    useLastImage: boolean;
    [key: string]: string|boolean|number|undefined|null;
}

/**
 * Class UgcBuild.
 *
 * Concrete implementation of UgcBuildInterface.
 */
export class UgcBuild implements UgcBuildInterface {
    public id!: string;
    public userId!: number;
    public itemId!: string;
    public revisionNotes: string = '';
    public status!: string;
    public name: string = '';
    public description: string = '';
    public price: number|null = null;
    public runningCost: number|null = null;
    public placementSound: number = 0;
    public placementSoundSize: number = 0;
    public category: string = '';
    public flexicolorOne: string = '';
    public flexicolorTwo: string = '';
    public flexicolorThree: string = '';
    public flexicolorFour: string = '';
    public theme: string = '';
    public sceneryType: string = 'SimpleScenery';
    public imgUuid: string = '';
    public useLastImage: boolean = false;
    [key: string]: string|boolean|number|undefined|null;
}

/**
 * UGC build item state interface.
 *
 * Note: at the moment no additional user information is required so our state only contains user session configuration.
 */
export interface UgcBuildStateInterface {
    revisions: UgcRevisionInterface[];
    item?: UgcItemInterface;
}

/**
 * UGC build item presigned response interface.
 */
export interface UgcBuildPresignedResponseInterface {
    original: string;
    presigned_url: string;
}

/**
 * UGC build item presigned request interface.
 */
export interface UgcBuildPresignedRequestInterface {
    build: UgcRevisionInterface;
    method: string;
    size?: number;
    filename?: string;
    extension: string;
}

export interface UgcBuildErrorCodeInteface {
    code: string;
    details?: string;
}

/**
 * UGC build item error code response interface.
 */
export interface UgcBuildErrorCodeResponseInterface {
    error_codes?: UgcBuildErrorCodeInteface[];
}
